import React, { useEffect, useState } from "react";
import TableFilterHeader from "../../components/TableHeader/TableFilterHeader";
import { useSelector, useDispatch } from "react-redux";
import { getUserList } from "../../store/redux/users";
import { getCardholderemessages, getCardholdermessages, getUsers } from "../../util/API/customers";
import TableInfoHeaderAgent from "../../components/TableInfoHeader/TableInfoHeaderAgent";
import { getCountryFlagUrl, searchAppsByLabel } from "../../util/utilfunctions/utilFunctions";
import OperatorTable from "../../components/OperatorTable/OperatorTable";
import OperatorCreation from "../../components/OperatorComponents/OperatorCreation/OperatorCreation";
import OperatorDetail from "../../components/OperatorComponents/OperatorDetail/OperatorDetail";
import { ListOperators } from "../../util/API/operator";
import { getOperatorsList } from "../../store/redux/operator";
import { GetOperatorsWithID } from "../../util/API/operator";
import { getUserRoles } from "../../util/API/login";
import { Box, Button, CircularProgress, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, Tab, Tabs } from "@mui/material";
import BaseDrawer from "../../components/UI/BaseDrawer/BaseDrawer";
import EditIcon from "../../images/editpencil.svg";
import BaseCustomerTable from "../../components/BaseCustomerTable/BaseCustomerTable";
import UserEmailTable from "../../components/UserEmailTable/UserEmailTable";
import SMStable from "../../components/SMSTable/SMStable";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      // aria-labelledby={`simple-tab-${index}`}
      {...other}
      className="tab-panel-container"
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </Box>
  );
}

function ViewOperators({ userid, selectedAgent, systemRoles, userStatus }) {
    const [selectedUser, setSelectedUser] = useState(null);
    const [filteredUsers, setFilteredUsers] = useState([]);
    const [open, setOpen] = useState(false);
    const [openDetail, setOpenDetail] = useState(false);
    const [selectedUserData, setSelectedUserData] = useState(null);
    const [searchText, setSearchText] = useState("");
    const [filterType, setFilterType] = useState(null);
    const [scrollPosition, setScrollPosition] = useState(0);
    const [operatorDetails, setOperatorDetails] = useState({
        firstName: "",
        lastName: "",
        businesscountry: "",
        email: "",
        subaccountEmail: "",
        status: "",
        phoneno: "",
    });
    const [operators, setOperators] = useState([]);
    const [securityPermissions, setSecurityPermissions] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    //Security Roles
    const [isLoading, setIsLoading] = useState(true);
    const [value, setValue] = useState(0);
    const [showData, setShowData] = useState("SMS");
    const [emailData, setEmailData] = useState([]);
    const [smsData, setSMSData] = useState([]);

    const securityAccess = useSelector((state) => state.login.securityAccess);
    const userInfo = useSelector((state) => state.login.user);
    let isAdmin = sessionStorage.getItem("isAdmin");

    useEffect(() => {
        const securityUser = searchAppsByLabel("agent", securityAccess);
        if (securityUser.length) {
            setSecurityPermissions(securityUser[0]);
        }
    }, []);
  
    const handleScroll = () => {
        const position = window.pageYOffset;
        setScrollPosition(position);
    };
  
    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    const handleOpen = () => setOpen(true);
    
    const handleClose = () => setOpen(false);
    
    const dispatch = useDispatch();

    async function getList() {
        let userList = await getUsers();
        dispatch(getUserList({ users: userList }));
    }

    useEffect(() => {
        getList();
    }, []);

    const pageCount = Math.ceil(filteredUsers.length / rowsPerPage);
    const pageNumbers = Array.from({ length: pageCount }, (_, index) => index);
    const handleChangePage = (event, newPage) => {
      console.log(newPage)
      setPage(newPage);
    };
  
    useEffect(() => {
        let filtered
        try {
            if (operators) {
                // console.log(operators)
                if (searchText.trim() === "") {
                    if (Array.isArray(operators?.VusersubacctRecs)) {
                        filtered = [...operators.VusersubacctRecs].reverse();
                    } else if (operators?.VusersubacctRecs) {
                        filtered = [operators.VusersubacctRecs];
                    } else {
                        filtered = [];
                    }
                
                setFilteredUsers(filtered.sort((a, b) => b.Vusersubacct.subacctid - a.Vusersubacct.subacctid));
                } else {
                    // filtered = operators?.VusersubacctRecs?.filter(
                    // (operator) =>
                    //     String(operator.Vusersubacct.firstName)
                    //     .toLowerCase()
                    //     .includes(searchText.toLowerCase()) ||
                    //     operator.Vusersubacct.countryname
                    //     .toLowerCase()
                    //     .includes(searchText.toLowerCase())
                    // );
                    filtered = operators?.VusersubacctRecs?.filter((operator) =>
                      String(operator.Vusersubacct.firstName)
                        .toLowerCase()
                        .includes(searchText.toLowerCase()) ||
                      operator.Vusersubacct.countryname
                        .toLowerCase()
                        .includes(searchText.toLowerCase()) ||
                      operator.Vusersubacct.emailAccount
                        ?.toLowerCase()
                        .includes(searchText.toLowerCase()) || // Check emailAccount
                      operator.Vusersubacct.lastName
                        ?.toLowerCase()
                        .includes(searchText.toLowerCase())    // Check lastName
                    );

                    setFilteredUsers(filtered.sort((a, b) => b.Vusersubacct.subacctid - a.Vusersubacct.subacctid));
                }
            }
        } catch (error) {
            
        } finally {
            // setIsLoading(false);
        }
        
    }, [operators, searchText]);
  
    const fetchOperators = async () => {
        if(userid && userid!== undefined) {
            try {
                const response = await ListOperators(userid);
                if (response?.payload) {
                    let operatorsList = response.payload.data;
                    setOperators(operatorsList);
                    dispatch(getOperatorsList({ users: operatorsList }));
                } else {
                    dispatch(getOperatorsList({ users: [] }));
                }
            } catch (error) {
                console.log("fetchOperators_error================", error);
            } finally {
                setIsLoading(false);
            }
        }
    };

    useEffect(() => {
        fetchOperators();
    }, [userid]);

    const setFilter = (filter) => {
        setFilterType(filter);
    };
    
  const handleSelectedUser = async (selectedOperator) => {
    setSelectedUser(selectedOperator.subacctid);

    console.log(selectedOperator)

    const userDetails = await GetOperatorsWithID(
      selectedOperator.subacctid
    ).then((response) => {
      if (response) {
        // console.log(response)
        setSelectedUserData(response.CustomerData);
        console.log(response.CustomerData)
        setOperatorDetails({
          firstName: response.CustomerData.User.firstName,
          lastName: response.CustomerData.User.lastName,
          businesscountry: response.CustomerData.User.countryid,
          email: response.CustomerData.User.other1,
          subemail: selectedOperator.emailAccount,
          // status: selectedOperator.active,
          status: response.CustomerData.User.status,
          phoneno: response.CustomerData.User.telephoneno,
          subuserid: response.CustomerData.User.id,
        });
      }
    });
    setOpenDetail(true);
  };

  const handleSearch = (searchText) => {
    setSearchText(searchText);
    if (searchText.trim() === "") {
      setFilteredUsers(operators?.VusersubacctRecs);
    } else {
      console.log("searchText------------",searchText);
      console.log("operators.VusersubacctRecs------------",operators?.VusersubacctRecs);
      // const filtered = operators.VusersubacctRecs.filter(
      //   (operator) =>
      //     operator.Vusersubacct.firstName
      //       .toLowerCase()
      //       .includes(searchText.toLowerCase()) ||
      //       operator.Vusersubacct.countryname
      //       .toLowerCase()
      //       .includes(searchText.toLowerCase())
      // );
      const filtered = operators.VusersubacctRecs.filter(
        (operator) =>
          (operator?.Vusersubacct?.firstName
            .toLowerCase()
            .includes(searchText.toLowerCase()) ||
            operator?.Vusersubacct?.countryname
              .toLowerCase()
              .includes(searchText.toLowerCase()) ||
            operator?.Vusersubacct?.emailAccount
              ?.toLowerCase()
              .includes(searchText.toLowerCase()) ||
            operator?.Vusersubacct?.lastName
              ?.toLowerCase()
              .includes(searchText.toLowerCase()))
      );
      console.log("filtered------------",filtered);

      setFilteredUsers(filtered);
    }
  };

  const handleUserCreated = () => {
    fetchOperators(); // Reload the list of operators
  };

  const handleChange = (event, newValue) => {
    console.log("handleTabChange============", newValue);
    setValue(newValue);
  };

  const handleTableChange = () => {
    if (showData == "SMS") {
      setShowData("email");
    } else {
      setShowData("SMS");
    }
  };

  let switchButtonText = showData === "email" ? "View SMS" : "View Emails";

  useEffect(()=> {
    if(value == 1) {
      getMessages();
    } else {
      setEmailData([]);
      setSMSData([]);
    }
  },[value]);

  const getMessages = async () => {
    try {
      setIsLoading(true);

      let smsMessages = await getCardholdermessages(
        selectedUserData?.User?.id,
        isAdmin
      );
      let emailMessages = await getCardholderemessages(
        selectedUserData?.User?.id
      );
      let emailRecord = [];
      if (Array.isArray(emailMessages?.data?.payload?.record)) {
        emailRecord = emailMessages?.data?.payload;
      } else {
        if (emailMessages?.data?.payload == "") {
          emailRecord = emailMessages?.data?.payload;
        } else {
          emailRecord["record"] = [emailMessages?.data?.payload?.record];
        }
      }
      if (smsMessages?.callStatus == 1) {
        setSMSData(smsMessages?.payload);
      }
      setEmailData(emailRecord);
    } catch (error) {
      console.log("getMessages_error===============", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      {filteredUsers ? (
        <>
          <OperatorCreation 
            open={open} 
            handleClose={handleClose}
            onUserCreated={handleUserCreated}
          />
          <Box className="">
            <Box>
              <Box
                className={`page-title ${
                  scrollPosition > 105 ? "fixed-filter-header" : ""
                }`}
                style={{ transition: "all 0.5s ease-in-out" }}
              >
                <Box className="crm-row-style">
                  <Typography
                  variant="h9"
                    className={scrollPosition > 105 ? "hide" : "padding-header"}
                  >
                    Operators
                  </Typography>
                  <TableFilterHeader
                    handleSearch={handleSearch}
                    setOpen={handleOpen}
                    createAllowed={""}
                    placeholder={"Search Operators"}
                  />
                </Box>
              </Box>
            </Box>

            {isLoading == true ? (
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "100%",
                        overflow: "hidden",
                    }}
                >
                    <CircularProgress />
                </Box>
                ) : (
                <Box className="customer-table-container">
                  <Box className="table-info-header pb-0 pt-0">
                    <Typography 
                      sx={{
                        color: "#00365a",
                        fontFamily: "Inter",
                        fontSize: "16px",
                        fontStyle: "normal",
                        fontWeight: 700,
                        lineHeight: "30px",
                      }}
                    >
                      Agent Name: {selectedAgent?.User?.firstName} {` `} {selectedAgent?.User?.lastName} {` `} ({selectedAgent?.Useremailaccount?.emailAccount})
                    </Typography>
                  </Box>
                    <TableInfoHeaderAgent
                        count={operators.recount}
                        setFilter={setFilter}
                        handleOpen={handleOpen}
                        user={"Operators"}
                    />
                    <OperatorTable
                        operatorData={filteredUsers}
                        handleSelectedUser={handleSelectedUser}
                        targetID="offcanvasRightLoan"
                        systemRoles={systemRoles}
                        userStatus={userStatus}
                    />
                  </Box>
                
                )}
            <Box
              className="offcanvas offcanvas-end dynamic-offcanvas"
              tabIndex="-1"
              id="offcanvasRightLoan"
              aria-labelledby="offcanvasRightLabel"
            >
              <Box className="customer-bottom-info">
                <Box className="text-end p-2">
                  <Button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="offcanvas"
                    aria-label="Close"
                  ></Button>
                </Box>
                <BaseDrawer
                  open={openDetail}
                  handleClose={() => {
                    setOpenDetail(false); 
                    setValue(0);
                    setEmailData([]);
                    setSMSData([]);
                  }}
                  height="90vh"
                  title={"Operator Account Details"}
                >
                  {/* <Box className="customer-bottom-box2">
                    <OperatorDetail
                      selectedUser={selectedUser}
                      setSelectedUserData={setSelectedUserData}
                      operatorDetails={operatorDetails}
                      handleClose={() => setOpenDetail(false)}
                      fetchOperators={fetchOperators}
                    />
                  </Box> */}

                  <Box sx={{ display: "flex", height: "100%" }}>
                    <Tabs
                        orientation="vertical"
                        variant="scrollable"
                        value={value}
                        onChange={handleChange}
                        sx={{
                            borderRight: 1,
                            borderColor: "divider",
                            //indicator color
                            "& .MuiTabs-indicator": {
                                backgroundColor: "#ff972c",
                            },
                            //selected tabs
                            "& .MuiButtonBase-root.Mui-selected": {
                                color: "#ff972c",
                            },
                            //non selected tabs
                            "& .MuiButtonBase-root": {
                                color: "rgba(0, 0, 0, 0.87)",
                            },
                        }}
                    >
                        <Tab label="Personal Information" />
                        <Tab label="Communications" />
                    </Tabs>

                    <TabPanel value={value} index={0}>
                      <Box className="customer-bottom-box2">
                        <OperatorDetail
                          selectedUser={selectedUser}
                          setSelectedUserData={setSelectedUserData}
                          operatorDetails={operatorDetails}
                          handleClose={() => setOpenDetail(false)}
                          fetchOperators={fetchOperators}
                        />
                      </Box>
                    </TabPanel>
                    <TabPanel value={value} index={1}>
                      <Box className="table-sizing" sx={{ overflow: "auto", backgroundColor:"#ffffff", padding:"20px" }}>
                        <Box
                          className="d-flex justify-content-end switch-button-container pointer"
                          onClick={handleTableChange}
                        >
                          <Box className="switch-button">{switchButtonText}</Box>
                        </Box>
                        {showData == "email" ? (
                          <UserEmailTable emailData={emailData} />
                        ) : (
                          <SMStable smsData={smsData} />
                        )}
                      </Box>
                    </TabPanel>
                    {/* <TabPanel value={value} index={2}>
                        <BundleFeeModule />
                    </TabPanel> */}
                  </Box>
                </BaseDrawer>
              </Box>
            </Box>
          </Box>
        </>
      ) : (
        <Box />
      )}
    </>
  );
}
export default ViewOperators;